import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { SortingAnswer } from "./sorting-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

@injectable()
export class SortingQuestionAnswerProtobufSerializer
  implements Api.StateSerializationPlugin<SortingAnswer> {
  key = {
    id: 19,
    name: { ns: "suspend-data", name: "question-answer-sorting" },
    format: "protobuf"
  };

  serialize(data: SortingAnswer): Result<Uint8Array, Api.SerializerError> {
    const message = new SortingAnswerProtoMessage({
      answerIdsOrder: data.answerIdsOrder
    });

    return ProtobufSerializer.serialize<SortingAnswerProtoMessage>(
      message,
      SortingAnswerProtoMessage
    );
  }

  deserialize(
    content: Uint8Array
  ): Result<SortingAnswer, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<
      SortingAnswerProtoMessage
    >(content, SortingAnswerProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const message = deserializeResult.value;
    const result: SortingAnswer = {
      answerIdsOrder: message.answerIdsOrder
    };

    return ok(result);
  }
}

@Type.d("SortingAnswerProtoMessage")
class SortingAnswerProtoMessage extends Message<SortingAnswerProtoMessage> {
  @Field.d(1, "string", "repeated")
  answerIdsOrder: string[];
}
